import * as React from "react";
import CTAButton, {
  formatContentfulCTA,
} from "../../../../buttons/cta-button/CTAButton";
import {css} from "/src/utils/utils";
import SimpleFormWrapper from "/src/components/forms/simple-form-wrapper/SimpleFormWrapper";
import {SimpleFormProps} from "/src/types";
import * as styles from "./basic-slide.module.scss";

interface Props extends Queries.CarouselSlideFragmentFragment {
  darkMode?: boolean;
}

export function BasicSlide(props: Props) {
  const {body, ctaButton, eyebrow, form, secondaryCtaButton, title, darkMode} =
    props;

  const caption = body?.body;
  const formatedCta = React.useMemo(
    () => (ctaButton ? formatContentfulCTA(ctaButton) : undefined),
    [ctaButton]
  );

  const formatedSecondaryCta = React.useMemo(
    () =>
      secondaryCtaButton ? formatContentfulCTA(secondaryCtaButton) : undefined,
    [secondaryCtaButton]
  );

  return (
    <React.Fragment>
      {eyebrow != null && (
        <div
          className={css(
            styles.basicSlide__eyebrow,
            darkMode ? styles.basicSlide__eyebrowDarkMode : ""
          )}
        >
          <p className="eyebrow">{eyebrow}</p>
        </div>
      )}

      {title != null && (
        <div
          className={css(
            styles.basicSlide__title,
            darkMode ? styles.basicSlide__titleDarkMode : ""
          )}
        >
          <h3 className="h3">{title}</h3>
        </div>
      )}

      <div
        className={css(
          styles.basicSlide__caption,
          darkMode ? styles.basicSlide__captionDarkMode : ""
        )}
      >
        <p className="p-small">{caption}</p>
      </div>

      {(formatedCta || formatedSecondaryCta) && (
        <div className={styles.basicSlide__btnGroup}>
          {formatedCta && (
            <span className={css(styles.basicSlide__btnGroup__button)}>
              <CTAButton
                darkMode={darkMode}
                kind="secondary"
                cta={formatedCta}
              />
            </span>
          )}

          {formatedSecondaryCta && (
            <span className={styles.basicSlide__btnGroup__button}>
              <CTAButton
                darkMode={darkMode}
                kind="tertiary"
                cta={formatedSecondaryCta}
              />
            </span>
          )}
        </div>
      )}

      {form != null && (
        <SimpleFormWrapper
          // TODO: Change prop types for SimpleFormWrapper to prevent type casting
          {...(form as SimpleFormProps)}
          contentClasses={styles.basicSlide__form}
        />
      )}
    </React.Fragment>
  );
}
